// Actions
export const setAdsBanner = ({ commit }, payload) => {
  commit('SET_ADS_BANNER', payload)
}
export const addAdsBanner = ({ commit }, payload) => {
  commit('ADD_ADS_BANNER', payload)
}
export const setAdsBannerLoading = ({ commit }, payload) => {
  commit('SET_ADS_BANNER_LOADING', payload)
}

export const setAawzFeed = ({ commit }, payload) => {
  commit('SET_AAWZ_FEED', payload)
}
export const addAawzFeed = ({ commit }, payload) => {
  commit('ADD_AAWZ_FEED', payload)
}
export const setAawzFeedLoading = ({ commit }, payload) => {
  commit('SET_AAWZ_FEED_LOADING', payload)
}

export const setExternalLinks = ({ commit }, payload) => {
  commit('SET_EXTERNAL_LINKS', payload)
}
export const addExternalLinks = ({ commit }, payload) => {
  commit('ADD_EXTERNAL_LINKS', payload)
}
export const setExternalLinksLoading = ({ commit }, payload) => {
  commit('SET_EXTERNAL_LINKS_LOADING', payload)
}

